/**
 * Configuration for the comparison-period feature of the Executive Summary
 * dashboard.
 *
 * These two knobs are independent:
 * - `defaultEnabled` controls the comparison VALUE when the URL has no explicit
 *   `compareEnabled` param (i.e. the first-load default).
 * - `showToggle` controls only whether the Compare on/off control is RENDERED.
 *   Hiding it never changes the value — the default (or a value already in the
 *   URL) still applies, so consumers keep getting a comparison range.
 */
export interface ExecutiveSummaryComparisonConfig {
    /** Comparison on/off default when the URL has no `compareEnabled` param. */
    defaultEnabled: boolean;
    /** Whether the Compare on/off toggle is shown in the selector popover. */
    showToggle: boolean;
}

export const EXECUTIVE_SUMMARY_COMPARISON_CONFIG: ExecutiveSummaryComparisonConfig =
    {
        defaultEnabled: true,
        showToggle: false,
    };
